import { memo, useState } from 'react';
import PropTypes from 'prop-types';
import { isEmpty } from 'lodash';
//Import Components
import AdminProviderCECModal from 'components/AdminProviderCECModal';
// Import Hooks
import useRequest from 'hooks/UseRequest';
import useCancelableRequests from 'hooks/UseCancelableRequests';
import useToaster from 'hooks/UseToaster';
// Import Services
import { AdministrationHttpService } from 'services/http';
// Import Constants
import { l, AlertTypes } from 'constants/common';
// Import Enums
import { PageTypesEnum } from 'enums';

const { success } = AlertTypes;

const AdminProviderActionsModals = (props) => {
    const {
        isCreateModalOpenedState,
        isEditModalOpenedState,
        isCloneModalOpenedState,
        modalsStateSetDict,
        openedModalData,
        onCloseModalHandler,
    } = props;
    const { doPostRequest } = useRequest();
    const { showToaster } = useToaster();

    const [isLoading, setIsLoading] = useState(false);

    const { setEmailProviderRequest, updateEmailProviderRequest } = useCancelableRequests({
        setEmailProviderRequest: AdministrationHttpService.setEmailProvider,
        updateEmailProviderRequest: AdministrationHttpService.updateEmailProvider,
    });

    const createOrCloneProvider = (provider, modalKey) => {
        setIsLoading(true);
        doPostRequest(setEmailProviderRequest.request, {
            requestBody: provider,
            successCallback: ({ AlertType, AlertMessage }) => {
                showToaster(success, l.ProviderCreated);
                onCloseModalHandler({
                    modalStateKey: modalKey,
                    alertType: AlertType,
                    alertMessage: AlertMessage,
                    isDoRefresh: true,
                });
            },
        }).then(() => setIsLoading(false));
    };

    const editProvider = (provider) => {
        setIsLoading(true);
        doPostRequest(updateEmailProviderRequest.request, {
            requestBody: provider,
            successCallback: ({ AlertType, AlertMessage }) => {
                showToaster(success, l.ProviderUpdated);
                onCloseModalHandler({
                    modalStateKey: modalsStateSetDict.editProvider.key,
                    alertType: AlertType,
                    alertMessage: AlertMessage,
                    isDoRefresh: true,
                });
            },
        }).then(() => setIsLoading(false));
    };

    return isEmpty(openedModalData) ? null : (
        <>
            {isCreateModalOpenedState && (
                <AdminProviderCECModal
                    onOk={(provider) => createOrCloneProvider(provider, modalsStateSetDict.createProvider.key)}
                    isVisibleModal={isCreateModalOpenedState}
                    onCancel={() =>
                        onCloseModalHandler({
                            modalStateKey: modalsStateSetDict.createProvider.key,
                        })
                    }
                    isLoading={isLoading}
                    type={PageTypesEnum.create}
                />
            )}
            {isEditModalOpenedState && (
                <AdminProviderCECModal
                    onOk={editProvider}
                    openedModalData={openedModalData}
                    isVisibleModal={isEditModalOpenedState}
                    onCancel={() =>
                        onCloseModalHandler({
                            modalStateKey: modalsStateSetDict.editProvider.key,
                        })
                    }
                    isLoading={isLoading}
                    type={PageTypesEnum.edit}
                />
            )}
            {isCloneModalOpenedState && (
                <AdminProviderCECModal
                    onOk={(provider) => createOrCloneProvider(provider, modalsStateSetDict.cloneProvider.key)}
                    openedModalData={openedModalData}
                    isVisibleModal={isCloneModalOpenedState}
                    onCancel={() =>
                        onCloseModalHandler({
                            modalStateKey: modalsStateSetDict.cloneProvider.key,
                        })
                    }
                    isLoading={isLoading}
                    type={PageTypesEnum.clone}
                />
            )}
        </>
    );
};

AdminProviderActionsModals.propTypes = {
    isCreateModalOpenedState: PropTypes.bool.isRequired,
    isEditModalOpenedState: PropTypes.bool.isRequired,
    isCloneModalOpenedState: PropTypes.bool.isRequired,
    modalsStateSetDict: PropTypes.object.isRequired,
    openedModalData: PropTypes.any.isRequired,
    onCloseModalHandler: PropTypes.func.isRequired,
};

export default memo(AdminProviderActionsModals);
